<template>
  <Base>
    <template #toolbar>
      <div class="toolbar" id="kt_toolbar">
        <div class="container-fluid d-flex flex-stack" id="kt_toolbar_container">
          <div class="d-flex align-items-center me-3">
            <span class="h-20px border-gray-200 border-start mx-4"></span>
            <ul class="breadcrumb breadcrumb-separatorless fw-bold fs-7 my-1">
              <li class="breadcrumb-item text-muted">
                <router-link :to="{ name: 'dashboard' }" class="text-muted text-hover-primary">
                  <i class="fad fa-home"></i> Tableau de bord
                </router-link>
              </li>
              <li class="breadcrumb-item"><span class="bullet bg-gray-200 w-5px h-2px"></span></li>
              <li class="breadcrumb-item text-dark">Comptes WhatsApp</li>
            </ul>
          </div>
          <div class="d-flex align-items-center py-1">
            <button class="btn btn-primary btn-sm" @click="resetForm" v-b-modal="'accountModal'">
              <i class="fad fa-plus me-1"></i> Nouveau compte
            </button>
          </div>
        </div>
      </div>
    </template>
    <template #content>
      <div class="card">
        <div class="card-body">
          <div v-if="accounts.length === 0" class="text-center text-muted py-10">
            <i class="fab fa-whatsapp fs-3x mb-3 d-block"></i>
            Aucun compte WhatsApp configure. Ajoutez-en un pour activer le multi-numero.
          </div>
          <div class="table-responsive" v-else>
            <table class="table table-striped align-middle">
              <thead>
                <tr class="fw-bolder text-muted">
                  <th>Nom</th>
                  <th>Numero</th>
                  <th>Phone Number ID</th>
                  <th class="text-center">Par defaut</th>
                  <th class="text-center">Actif</th>
                  <th class="text-end">Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="a in accounts" :key="a.id">
                  <td class="fw-bolder">{{ a.label }}</td>
                  <td class="text-muted">{{ a.displayNumber }}</td>
                  <td class="text-muted fs-8">{{ a.phoneNumberId }}</td>
                  <td class="text-center">
                    <i v-if="a.isDefault" class="fad fa-star text-warning"></i>
                  </td>
                  <td class="text-center">
                    <span v-if="a.isActive" class="badge badge-light-success">Actif</span>
                    <span v-else class="badge badge-light-danger">Inactif</span>
                  </td>
                  <td class="text-end">
                    <button class="btn btn-sm btn-light-warning me-1" @click="editAccount(a)" v-b-modal="'accountModal'">
                      <i class="fad fa-edit"></i>
                    </button>
                    <button class="btn btn-sm btn-light-danger" @click="deleteAccount(a)">
                      <i class="fad fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Modal Create/Edit -->
      <b-modal id="accountModal" :title="form.id ? 'Modifier le compte' : 'Nouveau compte'" centered size="lg" @ok.prevent="saveAccount">
        <div class="row">
          <div class="col-12 mb-3">
            <label class="required form-label">Nom</label>
            <b-form-input v-model="form.label" placeholder="Ex: Numero principal, Support client"></b-form-input>
          </div>
          <div class="col-6 mb-3">
            <label class="required form-label">Phone Number ID</label>
            <b-form-input v-model="form.phoneNumberId" placeholder="Ex: 154265981110971"></b-form-input>
          </div>
          <div class="col-6 mb-3">
            <label class="form-label">Numero affiche</label>
            <b-form-input v-model="form.displayNumber" placeholder="Ex: +225 07 89 98 69 79"></b-form-input>
          </div>
          <div class="col-12 mb-3">
            <label class="required form-label">Token</label>
            <b-form-input v-model="form.token" type="password" placeholder="Token d'acces WhatsApp Business API"></b-form-input>
          </div>
          <div class="col-12 mb-3">
            <label class="form-label">Webhook Secret</label>
            <b-form-input v-model="form.webhookSecret" placeholder="Secret de verification webhook (optionnel)"></b-form-input>
          </div>
          <div class="col-6 mb-3">
            <b-form-checkbox v-model="form.isActive">Actif</b-form-checkbox>
          </div>
          <div class="col-6 mb-3">
            <b-form-checkbox v-model="form.isDefault">Compte par defaut</b-form-checkbox>
          </div>
        </div>
      </b-modal>
    </template>
  </Base>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-property-decorator';
import Base from "@/layouts/Base.vue";
import {api} from "@/services/Api";

@Component({components: {Base}})
export default class WhatsappAccountManager extends Vue {
  accounts: any[] = []
  form: any = {}

  mounted() {
    this.loadAccounts()
  }

  resetForm() {
    this.form = {
      label: '', phoneNumberId: '', token: '',
      displayNumber: '', webhookSecret: '',
      isActive: true, isDefault: false
    }
  }

  editAccount(a: any) {
    this.form = {...a}
  }

  async loadAccounts() {
    this.$store.commit('loading')
    const res = await api.get(api.com, 'whatsapp/account/list')
    this.$store.commit('stopLoading')
    if (res?.data?.accounts) {
      this.accounts = res.data.accounts
    }
  }

  async saveAccount() {
    this.$store.commit('loading')
    const res = await api.post(api.com, 'whatsapp/account/edit', {account: this.form})
    this.$store.commit('stopLoading')
    if (res?.data?.status === 'success') {
      this.$bvModal?.hide?.('accountModal')
      await this.loadAccounts()
    }
  }

  async deleteAccount(a: any) {
    if (!confirm('Supprimer ce compte WhatsApp ?')) return
    await api.get(api.com, 'whatsapp/account/delete/' + a.id)
    await this.loadAccounts()
  }
}
</script>
